import { render } from "./COVID-19.vue?vue&type=template&id=8dd986ca&scoped=true"
const script = {}

import "./COVID-19.vue?vue&type=style&index=0&id=8dd986ca&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dd986ca"]])

export default __exports__